// Auto generated file, do not manually modify!
// com.hotpads.customeranalytics.client.enums.zgsearch.ZgSearchHomeType

export enum ZgSearchHomeType {
  APARTMENT = 'APARTMENT',
  MULTI_FAMILY = 'MULTI_FAMILY',
  SINGLE_FAMILY = 'SINGLE_FAMILY',
}

export const ZgSearchHomeType_values = [
  ZgSearchHomeType.APARTMENT,
  ZgSearchHomeType.MULTI_FAMILY,
  ZgSearchHomeType.SINGLE_FAMILY,
] as const;
